// Library: grid code families and versions of the region with family and status filters in the URL (S1).
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { zDocumentStatus } from "@/api/__generated__/zod.gen";
import { optionalList, optionalString } from "@/app/search";
import { LibraryPage, type LibrarySearch } from "@/features/library/LibraryPage";

const searchSchema = z.object({
  family: optionalString(),
  status: optionalList(zDocumentStatus),
});

export const Route = createFileRoute("/_app/$region/library/")({
  validateSearch: searchSchema,
  staticData: { crumb: "Library" },
  component: LibraryRoute,
});

function LibraryRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LibraryPage
      search={search}
      onSearchChange={(next: LibrarySearch) => {
        void navigate({ search: next, replace: true });
      }}
    />
  );
}
